module.exports = __webpack_public_path__ + "media/images/sp_header_btn_menu-3b751935f61dd8b52428825962f39276.png";